import { render } from "./VendorsIndex.vue?vue&type=template&id=00166c8c"
import script from "./VendorsIndex.vue?vue&type=script&lang=js"
export * from "./VendorsIndex.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__